<template>
  <base-section
    id="itp1-section"
    v-on:retry="props.onRetry"
    :heading="headingTitle"
    :infoStatus="itp1.infoStatus"
    :show-error="itp1.error"
  >
    <section-row title="Nuvarande placeringsval" :is-loading="itp1.isLoading">
      <section-row
        v-for="(placeringsval, index) in itp1.data?.nuvarandePlaceringsval"
        :key="index"
        :title="placeringsval.forsakringsbolagNamn"
        :value="placeringsval.procent"
      />
    </section-row>
    <section-row
      title="Belopp"
      :value="formattedAmountInCurrency(totalBelopp)"
      :value-is-numeric="true"
      :is-loading="itp1.isLoading"
    >
      <section-row
        v-for="p in itp1.data?.pensioner"
        :key="p.forsakringsbolagNamn!"
        :title="p.forsakringsbolagNamn"
        :sub-title="p.subtext"
        :value="formattedAmountInCurrency(p.belopp)"
        :value-is-numeric="true"
      />
    </section-row>
    <section-row
      title="Preliminärt belopp per månad"
      :value="formattedAmountInCurrency(itp1.data?.preliminartBeloppPerManad)"
      :value-is-numeric="true"
      :is-loading="itp1.isLoading"
    >
    </section-row>
  </base-section>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { BaseSection, SectionRow } from "@/components/sections";
import { formattedAmountInCurrency } from "@/common/formatters";

import { useAnstalldStore } from "../store";

type Itp1SectionProps = {
  onRetry?: () => void;
};

const props = defineProps<Itp1SectionProps>();
const anstalldStore = useAnstalldStore();
const itp1 = computed(() => anstalldStore.itp1);
const totalBelopp = computed(
  () =>
    itp1?.value?.data?.pensioner?.reduce((a, b) => {
      return a + (b?.belopp || 0);
    }, 0) || 0,
);

const headingTitle = computed(() => {
  const isActive = itp1.value.data?.isActive;

  if (!isActive && !itp1.value.isLoading) {
    return "Pensionsplan - ITP1 (Ej aktiv)";
  }

  return "Pensionsplan - ITP1";
});
</script>
